<template>
    <div :class="['card mb-5 shadow text-center', [pass.color] ]" ref="card">
        <div class="card-img" >
            <img class="card-img-top" :src="image" @click="download" />
            <p class="pass-number p-1">{{pass.passNumber}}</p>
            <p class="permit-number p-1">{{pass.permitNumber}}</p>
            <button class="btn red btn-sm btn-remove" v-if="removeable" @click="remove(pass)">
                <font-awesome-icon icon="trash-alt"></font-awesome-icon>
            </button>
        </div>
        <div class="card-body text-left ellipsis text-center">
            <strong>{{pass.permitNumber}} | {{pass.passNumber}}</strong>
        </div>
    </div>
</template>

<script>
export default {
    name: "pass",
    props: {
        pass: {
            required: true,
            type: Object
        },
        removeable: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        remove(pass) {
            if(this.removeable)
                this.$emit('remove', pass)
        },
        download() {
            if(!!this.pass.documentId)
            {
                this.$http.get("api/Pass/" + this.pass.documentId, { responseType: 'blob' }).then((res) => {
                    let blob = new Blob([res.data], { type: res.headers.get('content-type') });
                    let link = window.document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    
                    let disposition = res.headers.map["content-disposition"][0];
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    let matches = filenameRegex.exec(disposition);

                    if(matches != null && matches.length > 1)
                        link.download = matches[1];

                    window.document.body.appendChild(link);

                    link.click();

                    window.document.body.removeChild(link);
                });
            }
        }
    },
    computed: {
        image() {
            if(this.pass.document != null)
            {
                if(this.pass.document.file == null)
                    return URL.createObjectURL(this.pass.document);
                return 'data:' + this.pass.document.fileContent + ";base64, " + this.pass.document.file;
            }
            return "/img/rijnland.webp";
        }
    }
}
</script>

<style scoped lang="scss">
.btn-remove {
    position:absolute;
    bottom:0; 
    right:0;
}
.card-img
{
    cursor: pointer;
    position: relative;
    .permit-number,
    .pass-number {
        position:absolute;
        left:10px;
        z-index: 999;
        color: white;
        background-color: black;
        margin-bottom: 0;
        font-weight: bold;
    }
    .pass-number 
    {
        bottom: 5px;
    }
    .permit-number 
    {
        top: 5px;
    }
}
.card
{
    &.grey {
        background-color: #e9ecef;
    }
    &.green {
        color: white;
        background-color: #6AB558;
    }
    &.blue {
        color: white;
        background-color: #568AC6;
    }
    &.orange {
        color: white;
        background-color: #EB6E1E;
    }
    &.yellow {
        background-color: #FFE81A;
    }
}
</style>